const initialState = {
  isFetching: false,
  isFetched: false,
  page: 1,
  items: 10,
  total: 0,
  list: [],
  date: null,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "EVENTS/CATALOG_REQUEST":
      return { ...state, isFetching: true, isFetched: false };
    case "EVENTS/CATALOG_FAILURE":
      return { ...state, isFetching: false, isFetched: false };
    case "EVENTS/CATALOG_SUCCESS":
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        page: payload.page,
        total: payload.total,
        list: [...payload.events],
        date: null,
      };

    case "EVENTS/RESET":
      return initialState;
    default:
      return state;
  }
};

export default reducer;
